<template>
  <div class="faq" style="background-color: #fff;">
    <div class="u-flex banner" :style="page_img ? { backgroundImage: 'url(' + page_img + ')' } : ''"
      style="background-size: cover;">
      <div class="container">
        <h3>帮助中心</h3>
        <p>欢迎使用卓泓代理帮助中心</p>
        <div class="u-flex search">
          <el-input v-model="word" placeholder="输入您的问题关键词" />
          <el-button class="search-btn" type="primary" @click="getArticleList">搜索</el-button>
        </div>
      </div>
    </div>

    <div class="container" style="padding-bottom: 50px">
      <template v-for="item in articleList">
        <div class="module">
          <h3 class=" u-flex">{{ item.name }}</h3>
          <template>
            <ul class="u-flex u-flex-wrap ">
              <li v-for="item1 in item.document" :key="item1.id" @click="onView(item.id,item1.id)"
                style="display: flex;align-items: center;">
<!--                <img :src="item1.img_text" style="width: 20px;height: 20px;margin-right: 10px;" />-->
                <span>{{ item1.title }}</span>
              </li>

            </ul>
          </template>

        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Faq',
  data() {
    return {
      mIndex: 0,
      articleList: [],
      page_img: '',

      word: '', // 新增，解决v-model=word报错
    }
  },
  created() {
    this.getArticleList()
  },
  mounted() { },
  methods: {
    getArticleList() {
      this.$api.document.getFaq({ word: this.word }).then(res => {
        this.articleList = res.data.list
        this.page_img = res.data.page_img
      })
    },
    onTab(index) {
      this.mIndex = index
    },
    onView(cid,id) {
      this.$router.push({
        path:'/FaqDetail',
        query:{
          id:id,
          cid:cid
        }
      })
    }
  },
}
</script>

<style scoped>
.banner {
  margin-top: 80px;
  padding: 100px 0;
  background: url(../assets/images/bzzx_bg.png) no-repeat 100%;
}

.banner h3 {
  color: #114672;
  font-size: 30px;
}

.banner p {
  margin-top: 20px;
  color: #999;
  font-size: 16px;
}

.search {
  margin-top: 30px;
  width: 480px;
}

.search ::v-deep.el-input__inner {
  border: 0;
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-btn {
  padding: 12px 40px;
  border: 0;
  background: #2682ff;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.menu {
  height: 140px;
  background: #f2f7fd;
}

.menu .active .name {
  color: #2682ff;
}

.icon {
  width: 30px;
  height: 30px;
  display: block;
}

.name {
  color: #333;
  font-size: 18px;
}

.desc {
  margin-top: 4px;
  color: #999;
  font-size: 12px;
}

.module {
  margin-top: 30px;
  margin-bottom: 30px;
}

.module h3 {
  font-size: 16px;
}

.module h3 img {
  margin-right: 10px;
  width: 40px;
  height: 40px;
  display: block;
}

.module ul {
  margin-top: 20px;
  padding: 20px;
  background: #f1f5f8;
}

.module ul li {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
}

.module ul li:hover {
  color: #207bff;
}
</style>
